// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.how-it-works {
  padding: 4rem 0;
  background: white;
}

.how-it-works-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

.how-it-works-title {
  font-size: 2.5rem;
  font-weight: bold;
  text-align: center;
  color: #1e293b;
  margin-bottom: 3rem;
}

.steps {
  display: grid;
  grid-template-columns: 1fr;
  gap: 3rem;
  max-width: 900px;
  margin: 0 auto;
}

.step {
  display: flex;
  gap: 1.5rem;
  align-items: flex-start;
  padding: 1.5rem;
}

.step-icon {
  width: 5rem;
  height: 5rem;
  background: #e0f2fe;
  border-radius: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  flex-shrink: 0;
}

.step-content {
  flex: 1 1;
}

.step-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 1rem;
}

.step-description {
  color: #64748b;
  line-height: 1.7;
  font-size: 1rem;
}

@media (max-width: 768px) {
  .how-it-works {
    padding: 3rem 0;
  }

  .how-it-works-title {
    font-size: 2rem;
  }

  .step {
    flex-direction: column;
    text-align: center;
    padding: 1rem;
  }

  .step-icon {
    margin: 0 auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/GuestPage/how-It-Work/HowItWorks.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".how-it-works {\n  padding: 4rem 0;\n  background: white;\n}\n\n.how-it-works-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 1rem;\n}\n\n.how-it-works-title {\n  font-size: 2.5rem;\n  font-weight: bold;\n  text-align: center;\n  color: #1e293b;\n  margin-bottom: 3rem;\n}\n\n.steps {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 3rem;\n  max-width: 900px;\n  margin: 0 auto;\n}\n\n.step {\n  display: flex;\n  gap: 1.5rem;\n  align-items: flex-start;\n  padding: 1.5rem;\n}\n\n.step-icon {\n  width: 5rem;\n  height: 5rem;\n  background: #e0f2fe;\n  border-radius: 0.75rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 2rem;\n  flex-shrink: 0;\n}\n\n.step-content {\n  flex: 1;\n}\n\n.step-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #1e293b;\n  margin-bottom: 1rem;\n}\n\n.step-description {\n  color: #64748b;\n  line-height: 1.7;\n  font-size: 1rem;\n}\n\n@media (max-width: 768px) {\n  .how-it-works {\n    padding: 3rem 0;\n  }\n\n  .how-it-works-title {\n    font-size: 2rem;\n  }\n\n  .step {\n    flex-direction: column;\n    text-align: center;\n    padding: 1rem;\n  }\n\n  .step-icon {\n    margin: 0 auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
